import { tryOnScopeDispose } from '@vueuse/core'
export const useTimedNavigation = () => {
  const { navigation } = useNavigationStore()

  let interval: ReturnType<typeof setInterval>
  const refreshKey = ref(1)

  const isValid = (item:NavigationItem) => {
    if (!item.validFromTimestamp && !item.validUntilTimestamp) { return true }
    return item.validFromTimestamp <= Date.now() && (!item.validUntilTimestamp || Date.now() <= item.validUntilTimestamp)
  }

  const timedNavigation = ({ filterByLocation = null }) => {
    const returnData = ref<NavigationItem[]>([])
    navigation.forEach(item => {
      item.valid = isValid(item) && !!refreshKey.value

      if (item.subItems?.length) {
        item.subItems.forEach(item => {
          item.valid = isValid(item) && !!refreshKey.value
        })
      }
      if (item.highlights?.length) {
        item.highlights.forEach(item => {
          item.valid = isValid(item) && !!refreshKey.value
        })
      }

      if ((!filterByLocation || item.location === filterByLocation)) {
        returnData.value.push(item)
      }
    })

    return returnData.value
  }

  onMounted(() => {
    clearInterval(interval)
    interval = setInterval(() => {
      refreshKey.value = Date.now()
    }, 300000)
  })

  tryOnScopeDispose(() => {
    clearInterval(interval)
  })

  return { timedNavigation }
}
